// /platform/sync-events — cross-tenant аудит-журнал 1С-обмена для
// PLATFORM_ADMIN (PA-13 / D17 §2.3).
//
// Wrapper над `PlatformSyncEventsScreen` (отдельный экран, не reuse
// `RecentEventsTable` — обоснование в самом screen-файле).
//
// Route-level guard `redirectIfNotPlatformAdmin` — distributor-scoped
// пользователь редиректится на /dashboard. Дополнительная permission
// `platform.sync-events.view-all` проверяется внутри screen'а (Banner).

import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { PlatformSyncEventsScreen } from '../features/platform/PlatformSyncEventsScreen'
import { redirectIfNotPlatformAdmin } from '../lib/platformAdminGuard'

export const Route = createFileRoute('/platform/sync-events')({
  beforeLoad: () => {
    redirectIfNotPlatformAdmin(redirect)
  },
  component: PlatformSyncEventsRoute,
})

function PlatformSyncEventsRoute() {
  return (
    <RequireAuth>
      <PlatformSyncEventsScreen />
    </RequireAuth>
  )
}
